import { type SpacingToken } from '@backrs_ui/common-ui';

// Horizontal gutter for page content; shared so adjacent shell elements align to the same edge.
export const CONTENT_GUTTER: SpacingToken = 'spacing-3xl';

// DOM id of the page-body scroll container.
export const PAGE_SCROLL_ID = 'backrs-page-scroll';

// DOM id of the outer content area, which wraps the page-body scroller.
export const LAYOUT_SCROLL_ID = 'backrs-layout';
